import { Button, LinearProgress, Table, TableBody, TableCell, TableHead, TableRow } from 'beam'
import { Formik } from 'formik'
import moment from 'moment'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import NguiSnackbar from '../../../../Common/NguiSnackbar'
import { useUser } from '../../../../Permissions'
import AppMgmtForm from '../../Common/Form'
import { useBulkContactExports } from './useBulkContactExports'

export function BulkContactExportMonitoring(): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: remove non null assertion
  const user = useUser()!
  const { t } = useTranslation()
  const bces = useBulkContactExports()
  return <>
    {bces.isLoading && <LinearProgress color="secondary" data-testid="BulkContactExportMonitoring-LoadingIndicator" />}
    <NguiSnackbar
      open={bces.hasError}
      variant="error"
      autoHideDuration={null}
      closeCallback={() => bces.resetError()}
      onClose={() => bces.resetError()}
      data-testid="BulkContactExportMonitoring-ErrorSnackbar"
      message={<>
        <div data-testid="BulkContactExportMonitoring-ErrorSnackbarMessage">{bces.errorMessage}</div>
        {bces.errorRequestId && <div data-testid="BulkContactExportMonitoring-ErrorSnackbarRequestId">{t('requestID')}: {bces.errorRequestId}</div>}
      </>}
    />
    <Formik initialValues={{}} onSubmit={() => { /** form will never be submitted */}}>
      <AppMgmtForm
        title={t('bulkExportAudit')}
        description={t('bulkExportAuditDescription')}
        buttons={[
          <Button
            key="0"
            variant="outlined"
            color="primary"
            onClick={() => bces.refresh()}
            disabled={bces.isLoading}
            data-testid="BulkContactExportMonitoring-RefreshButton"
          >
            {t('refresh')}
          </Button>,
          <Button key="1" href="/classic/#/admin" data-testid="BulkContactExportMonitoring-BackButton">
            {t('cancel')}
          </Button>,
        ]}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('date')}</TableCell>
              <TableCell>{t('name')}</TableCell>
              <TableCell>{t('status')}</TableCell>
              <TableCell>{t('contactsEvaluatedTitle')}</TableCell>
              <TableCell>{t('invalidContactsTitle')}</TableCell>
              <TableCell>{t('contactsSubmittedTitle')}</TableCell>
              <TableCell>{t('contactsExportedTitle')}</TableCell>
              <TableCell>{t('jobOwnerTitle')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bces.data?.map(bce => (
              <TableRow key={bce.bceExecutionId}>
                <TableCell><span data-testid={`BulkContactExportMonitoring-Date-${bce.bceExecutionId}`}>{moment.tz(bce.jobStartTime, user.timezoneString).format('MM/DD/YYYY HH:mm:ss')}</span></TableCell>
                <TableCell><span data-testid={`BulkContactExportMonitoring-Name-${bce.bceExecutionId}`}>{bce.jobName}</span></TableCell>
                <TableCell><span data-testid={`BulkContactExportMonitoring-Status-${bce.bceExecutionId}`}>{bce.jobStatus}</span></TableCell>
                <TableCell><span data-testid={`BulkContactExportMonitoring-Total-${bce.bceExecutionId}`}>{bce.numberOfTotalContacts}</span></TableCell>
                <TableCell><span data-testid={`BulkContactExportMonitoring-Invalid-${bce.bceExecutionId}`}>{bce.numberOfInvalidContacts}</span></TableCell>
                <TableCell><span data-testid={`BulkContactExportMonitoring-Submitted-${bce.bceExecutionId}`}>{bce.numberOfContactsSubmitted}</span></TableCell>
                <TableCell><span data-testid={`BulkContactExportMonitoring-Exported-${bce.bceExecutionId}`}>{bce.numberOfContactsExported}</span></TableCell>
                <TableCell><span data-testid={`BulkContactExportMonitoring-Owner-${bce.bceExecutionId}`}>{bce.jobOwnerFirstName} {bce.jobOwnerLastName}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </AppMgmtForm>
    </Formik>
  </>
}
